import { IProduct } from "$containers";
import useJStyles from "$hooks/useJStyles";
import { Modal, Text } from "$components";
import JTable from "$components/JTable/JTable";
import { EDBIntegratedOrders } from "$types/EDBIntegratedOrders";
import useEDBIntegratedOrdersTable from "../../hooks/useIntegratedOrdersTable";

type Props = {
  className?: string;
  integratedOrders: EDBIntegratedOrders;
  handleClickProduct: (product: IProduct) => void;
  setIntegratedOrders: (integratedOrders: EDBIntegratedOrders) => void;
};

function IntegratedOrdersTable({
  className,
  integratedOrders,
  handleClickProduct,
  setIntegratedOrders,
}: Props) {
  const { jclasses } = useJStyles();

  const {
    openConfirmDelete,
    allProductsBySuborder,
    handleCancelDialog,
    handleAllValidateDialog,
    getAllProductsColumns,
    getAllProductsData,
  } = useEDBIntegratedOrdersTable({
    integratedOrders,
    setIntegratedOrders,
  });

  return (
    <>
      {allProductsBySuborder?.map((productsBySuborder) => (
        <JTable
          key={productsBySuborder.suborderReference}
          columns={getAllProductsColumns(productsBySuborder)}
          data={getAllProductsData(productsBySuborder.products)}
          hideCheckboxes
          hideFilters
          usePaper={false}
          setPageIndex={() => {}}
          className={className}
          rowProps={(row) => ({
            onClick: () => handleClickProduct(row.original._product),
            style: { cursor: "pointer" },
          })}
        />
      ))}
      <Modal
        title="Confirmation de suppression"
        open={openConfirmDelete}
        onCancel={handleCancelDialog}
        onValidate={handleAllValidateDialog}
      >
        <div className={jclasses.jDialogContent}>
          <Text>Êtes vous sûr de vouloir continuer ?</Text>
        </div>
      </Modal>
    </>
  );
}

export default IntegratedOrdersTable;
